module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "info"
  }, [_c('p', [_vm._v("The Schoox HotSchedules Integration Administration system handles mappings between Schoox Academies and HotSchedules locations, manages configurations of those mappings, synchronizes Schoox user records based on HotSchedules user information, and provides tools for troubleshooting and problem-solving.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-bf070260!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 418
// module chunks = 2